import React, { useRef } from 'react';
import { createPortal } from 'react-dom';

import useOnClickOutside from '../../hooks/useOnClickOutside';

type Props = {
	show: boolean;
	children: React.ReactNode;
	close: () => void;
};

function Modal({ show, children, close }: Props) {
	const ref = useRef(null);
	useOnClickOutside(ref, (): any => {
		close();
	});


	const modalContent = show ? (
		<div className="modal">
			<div className="modal-body" ref={ref}>
				{children}
			</div>
		</div>
	) : null;

	return modalContent ? createPortal(modalContent, document.body) : null;
}

Modal.defaultProps = {
	show: false
};

export default Modal;